/* Remix Helper */

import TextPhotoDefaults from "../enums/TextPhotoDefaults";
import CanvasHelper from "./CanvasHelper";
import LayerIdGenerator from "./LayerIdGenerator";
import FileHelper from "./FileHelper";
import PhotoResizer from "./PhotoResizer";

const REACT_APP_PZ_IMAGE_SRC = process.env.REACT_APP_PZ_IMAGE_SRC;
const REACT_APP_PZ_VIDEO_SRC = process.env.REACT_APP_PZ_VIDEO_SRC;
const REACT_APP_MAX_UPLOAD_PHOTO_WIDTH = parseInt(process.env.REACT_APP_MAX_UPLOAD_PHOTO_WIDTH);
const REACT_APP_MAX_UPLOAD_PHOTO_HEIGHT = parseInt(process.env.REACT_APP_MAX_UPLOAD_PHOTO_HEIGHT);
const EXPRESS_URL = process.env.REACT_APP_EXPRESS_URL;
const randomIntFromInterval = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

const RemixHelper = {
  getDefaultRemixArguments: () => {
    return {
      app: 'web',
      rde: ' ||) ',
      blksnow: '0',
      edate: '00',
      mvon: 0,
      rfsownernm: 30,
      sdate: '00',
      rpdt: '3.00',
      rperm: '3',
      rssm: 1,
      easv: '3',
      rautoapp: '0',
      rdmdown: 1,
      dppref: 1,
      blksae: '0',
      blksbs : '0',
      rmcsa: '1',
      rpsende: '3',
      ebo: 'PictureDescription',
      rops: 11,
      tsocial: 0,
      rinsta: 1,
      rsmir: 0,
      rpsmc: '3'
    };
  },

  generateStarTag: (text) => {
    let startag = text;

    // Setting lower case
    startag = startag.toLowerCase();

    // Trimm string
    startag = startag.trim();

    // Adding underscore
    startag = startag.replaceAll(' ', '_');

    // Removing breakline
    startag = startag.replaceAll('\n', '');
    startag = startag.replaceAll('\r', '');

    // Removing emojis
    startag = startag.replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '');

    // Removing symbols
    startag = startag.replace(/[&/\\#\-@ˆ%,+=()$~%.`'":*!?;|<>{}]/g, '');

    // Replacing double underscore
    startag = startag.replaceAll('__', '');

    // Replacing special chars
    startag = startag.replaceAll('ç', 'c');

    // Normalize the string to remove accents
    startag = startag.normalize('NFD').replace(/[\u0300-\u036f]/g, "");

    if (startag.length > 24) {
      startag = startag.substring(0, 23);
    }

    return startag;
  },

  randomizeStyle: async (styles, catsImages, previousSelected = null) => {
    let selectedStyle;
    if (styles && styles.length > 0) {
      let selected = false;
      let whileCount = 0;
      while (!selected && whileCount < 5) {
        const maxRandom = (styles.length > 16) ? 15 : styles.length - 1;
        const random = randomIntFromInterval(0, maxRandom);
        selectedStyle = (styles[random]);
        if (previousSelected) {
          if (previousSelected.id !== selectedStyle.id) {
            selected = true;
          }
        } else {
          selected = true;
        }
      }
      whileCount ++;
    }

    if (selectedStyle) {
      // const backgroundsImgs = catsImages.biu.replace(/https?:\/\//, 'http://') + '/';
      const backgroundsImgs = 'https://pbmp-remoteassets.pepblast.com/mov_bg/img-1920x1080/';
      const backImgLoc = selectedStyle.backImgLoc;
      const posterSrc = `${backgroundsImgs}${backImgLoc}`;
      const videoSrc = EXPRESS_URL.replace('{id}', selectedStyle.id);
      selectedStyle.posterSrc = posterSrc;
      selectedStyle.videoSrc = videoSrc;
    }
    
    return selectedStyle;
  },

  randomizeSong: async (style, songs) => {
    const filteredSongsIts = [];
    if (style && songs && songs.its && songs.its.length > 0) {
      songs.its.forEach((item) => {
        if (item.ci && item.ci.includes(style)) {
          filteredSongsIts.push(item);
        }
      });
    }

    let selectedSong;
    if (filteredSongsIts && filteredSongsIts.length > 0) {
      const maxRandom = (filteredSongsIts.length > 16) ? 15 : filteredSongsIts.length - 1;
      const random = randomIntFromInterval(0, maxRandom);
      selectedSong = (filteredSongsIts[random]);
    } else if (songs && songs.its && songs.its.length > 0) {
      // Select any other random song
      const maxRandom = (songs.its.length > 16) ? 15 : songs.its.length - 1;
      const random = randomIntFromInterval(0, maxRandom);
      selectedSong = (songs.its[random]);
    }
    
    return selectedSong;
  },

  randomizeMediaPack: (style, genresMap, map) => {
    let result = null;
    if (style && map) {
      if (map[style]) {
        result = map[style].mediapack;
      }
    } else if (style && genresMap && genresMap.length > 0) {
      const filteredItem = genresMap.filter((value) => {
        return parseInt(value.catid) === parseInt(style);
      });
      // Style is in genres map
      if (filteredItem.length > 0) {
        result = parseInt(style);
      }
    }

    if ((result === null) && genresMap && genresMap.length > 0) {
      // Generating a random style for media pack
      const maxRandom = genresMap.length - 1;
      const random = randomIntFromInterval(0, maxRandom);
      const selectedStyle = genresMap[random];
      if (selectedStyle && selectedStyle.catid) {
        result = parseInt(selectedStyle.catid);
      }
    }

    return result;
  },

  generateTextPhoto: async (text, photo, photoWidth = null, photoHeight = null) => {
    const canvas = document.createElement('canvas');
    canvas.width = TextPhotoDefaults.CANVAS_DEFAULT_WIDTH;
    canvas.height = TextPhotoDefaults.CANVAS_DEFAULT_HEIGHT;

    const layers = [];
    layers[0] = { id: LayerIdGenerator.generate(), type: 'image', file: null, dataUri: photo };
    layers[1] = { id: LayerIdGenerator.generate(), type: 'shadow', color: TextPhotoDefaults.CANVAS_DEFAULT_BACKGROUND_COLOR };
    if (text.length > 0) {
      text.forEach((item, index) => {
        layers[index + 2] = {
          id: LayerIdGenerator.generate(), 
          type: 'text', 
          content: item, 
          x: canvas.width/2,
          color: TextPhotoDefaults.CANVAS_DEFAULT_TEXT_COLOR,
          fontSize: TextPhotoDefaults.CANVAS_DEFAULT_FONT_SIZE,
          font: TextPhotoDefaults.CANVAS_DEFAULT_FONT,
          textAlign: TextPhotoDefaults.CANVAS_DEFAULT_TEXT_ALIGN
        };
      });
    }

    try {
      let lineHeightSum = (text.length > 3) ? (-1 * ((text.length - 3) * TextPhotoDefaults.CANVAS_DEFAULT_LINE_HEIGHT)) :  0;
      for (const item of layers) {
        if (item && item !== null) {
          if (item.type) {
            if (item.type === 'image') {
              await CanvasHelper.addImage({ canvas: canvas, imageDataURI: item.dataUri })
            } else if (item.type === 'shadow') {
              CanvasHelper.addBackgroundColor({ canvas: canvas, color: item.color });
            } else if (item.type === 'text') {
              item.y = canvas.height/2 + lineHeightSum;

              const renderedSizes = CanvasHelper.addText({
                canvas: canvas,
                text: item.content,
                color: item.color,
                x: item.x,
                y: item.y,
                fontSize: item.fontSize,
                font: item.font,
                textAlign: item.textAlign
              });

              if (renderedSizes && renderedSizes.w) {
                item.renderedW = renderedSizes.w;
              }
              if (renderedSizes && renderedSizes.h) {
                item.renderedH = renderedSizes.h;
                lineHeightSum += renderedSizes.h;
              }

              if (photoWidth) {
                item.w = photoWidth;
              }
              if (photoHeight) {
                item.h = photoHeight;
              }
            }
          }
        }
      }
  
      const base64Final = canvas.toDataURL('image/jpeg', 0.8);
  
      return {layers, renderedImage: base64Final};
    } catch (err) {
      return false;
    }
  },

  generateBasePhotoWithLayer: async (layers) => {
    const canvas = document.createElement('canvas');
    canvas.width = TextPhotoDefaults.CANVAS_DEFAULT_WIDTH;
    canvas.height = TextPhotoDefaults.CANVAS_DEFAULT_HEIGHT;

    if (layers.length < 2) {
      return false;
    }

    try {
      for (const item of layers) {
        if (item && item !== null) {
          if (item.type) {
            if (item.type === 'image') {
              await CanvasHelper.addImage({ canvas: canvas, imageDataURI: item.dataUri })
            } else if (item.type === 'shadow') {
              CanvasHelper.addBackgroundColor({ canvas: canvas, color: item.color });
            }
          }
        }
      }
  
      const base64Final = canvas.toDataURL('image/jpeg', 0.8);
  
      return base64Final;
    } catch (err) {
      return false;
    }
  },

  intercalateArrays: (photos, textPhotos) => {
    let elements = [];
    const photosLength = photos.length;
    const textPhotosLength = textPhotos.length;

    if (photosLength > 0 && textPhotosLength > 0) {
      const totalLength = photosLength + textPhotosLength;

      let indexPhoto = 0;
      let indexText = 0;

      if (textPhotosLength === 1) {
        for (let i=0;i<totalLength;i++) {
          if (i === 1) {
            elements.push(textPhotos[indexText]);
            indexText ++;
          } else {
            elements.push(photos[indexPhoto]);
            indexPhoto ++;
          }
        }
      } else if (textPhotosLength === 2) {
        for (let i=0;i<totalLength;i++) {
          if (i === 1 || i === totalLength - 3) {
            elements.push(textPhotos[indexText]);
            indexText ++;
          } else {
            elements.push(photos[indexPhoto]);
            indexPhoto ++;
          }
        }
      } else {
        const middleElementsLength = totalLength - 5;
        const interval = parseInt((photosLength - 3) / (textPhotosLength - 2)) - 1;

        let middleElements = [];
        let middlePhotosElements = [];
        let middleTextPhotoElements = [];
        for (let i=1;i<photosLength - 2;i++) {
          middlePhotosElements.push(photos[i]);
        }
        for (let i=1;i<textPhotosLength - 1;i++) {
          middleTextPhotoElements.push(textPhotos[i]);
        }

        let intervalCounter = 0;
        for (let i=0;i<middleElementsLength;i++) {
          if (intervalCounter < interval) {
            middleElements.push(middlePhotosElements[indexPhoto]);
            intervalCounter ++;
            indexPhoto ++;
          } else {
            middleElements.push(middleTextPhotoElements[indexText]);
            indexText ++;
            intervalCounter = 0;
          }
        }

        elements = [
          photos[0],
          textPhotos[0],
          ...middleElements,
          textPhotos[textPhotosLength - 1],
          photos[photosLength - 2],
          photos[photosLength - 1]
        ];
      }
    }
    return elements;
  },

  generateTextLayerBreakLine: (item) => {
    const canvas = document.createElement('canvas');
    canvas.width = TextPhotoDefaults.CANVAS_DEFAULT_WIDTH;
    canvas.height = TextPhotoDefaults.CANVAS_DEFAULT_HEIGHT;

    let rendered = CanvasHelper.addTextWrap({
      canvas: canvas,
      text: item.content,
      color: item.color,
      font: item.font, 
      fontSize: item.fontSize,
      textAlign: item.textAlign,
    });

    return rendered;
  },

  processItsForMediaGrid: async (its, type) => {
    if (its && its.length > 0) {
      const media = [];

      if (type === 'mediapack') {
        its.forEach((item) => {
          if (item.eid) {
            item.src = REACT_APP_PZ_IMAGE_SRC.replace('{id}', item.eid);
            item.type = type;
          }
          media.push(item);
        });
      } else if (type === 'file') {
        for (let i = 0; i < its.length; i++) {
          const file = its[i];
          var FileDataUri = await FileHelper.readFile(file);

          let fileType;
          if (file && file.type) {
            if (file.type.includes('image/')) {
              fileType = 'file';
              FileDataUri = await PhotoResizer({
                src: FileDataUri,
                maxWidth: REACT_APP_MAX_UPLOAD_PHOTO_WIDTH,
                maxHeight: REACT_APP_MAX_UPLOAD_PHOTO_HEIGHT
              });
            }
            else if (file.type.includes('video/')) { fileType = 'video'; }
          }

          const item = {
            file: file,
            src: FileDataUri,
            type: fileType
          };
          media.push(item);
        }
      } else if (type === 'textphoto') {
        its.forEach((item) => {
          const itemToSet = {
            src: item.renderedImage,
            type: type,
            layers: item.layers
          };
          media.push(itemToSet);
        });
      } else if (type === 'unsplash') {
        for (let i = 0; i < its.length; i++) {
          const photo = its[i];
          if (photo && photo.urls && photo.urls.regular) {
            const FileDataUri = await CanvasHelper.getBase64ImageFromURL(photo.urls.regular);
            const item = {
              src: FileDataUri,
              type: type,
              name: `${photo.id}.jpeg`
            };
            media.push(item);
          }
        }
      }

      return media;
    } else {
      return false;
    }
  },

  getRemixDescOnly: ((rde) => {
    const separator = '||)';
    let description = '';
    if (rde) {
      description = rde;
      if (rde.includes(separator)) {
        const splitted = rde.split(separator);
        if (splitted && splitted[0]) {
          description = splitted[0];
        }
      }
    }
    return description;
  }),

  convertCreateDateToAlbumDate: ((createDate) => {
    createDate = `${createDate}`;
    let date = '';
    if (createDate) {
      const day = createDate.substring(6, 8);
      const month = createDate.substring(4, 6);
      const year = createDate.substring(2, 4);
      date = `${month}/${day}/${year}`;
    }
    return date;
  }),

  convertCreateDateToAlbumYear: ((createDate) => {
    createDate = `${createDate}`;
    let date = '';
    if (createDate) {
      const year = createDate.substring(0, 4);
      date = year;
    }
    return date;
  }),

  getRemixMediaImageUrl: (({ eid, emdate}) => {
    let url = (eid) ? REACT_APP_PZ_IMAGE_SRC.replace('{id}', eid) : null;
    if (url && emdate) { url += `?emdate=${emdate}`; }
    return url;
  }),

  getRemixMediaVideoUrl: (({ eid, emdate }) => {
    let url = (eid) ? REACT_APP_PZ_VIDEO_SRC.replace('{id}', eid) : null;
    if (url && emdate) { url += `?emdate=${emdate}`; }
    return url;
  }),

}

export default RemixHelper;
